import React, { Component } from 'react';
import styles from '../Questionnaire/NewPatientQuestionnaire.module.css';
import style from './NewPatientSummary.module.css';
import Zoom from 'react-medium-image-zoom';
import StarRateIcon from '@material-ui/icons/StarRate';
import { Box, Grid, Typography } from '@material-ui/core';
import FormLabel from '@material-ui/core/FormLabel';
import { connect } from 'react-redux';
import { withLang } from '../../../util/lang';
import { getWebAbsPath } from '../../../util/path';
import { smileDesignProductListArray } from '../../../store/SmileDesign/SmileDesignSlice';
import SmileDesignPrescriptionNotesPreview from '../../../pages/SmileDesign/SmileDesignPrescriptionNotesPreview';
// import SmileDesignPrescriptionNotesPreviewMap from '../../../pages/SmileDesign/SmileDesignPrescriptionNotesPreviewMap';
import ReadOnlyPrescription from '../../DifferentRetainer/components/ReadOnlyPrescription/readOnlyPrescription';
import { getPrescriptionValue } from './utils';
import {
    Base_Prescription_Err,
    Base_Retainer_Request_Err,
    Base_Smile_Design_Prescription_Err,
    CASE_TYPE,
} from '../../../store/NewPatient/utils';
import ReadOnlySpecialInstruction from '../../DifferentRetainer/components/ReadOnlyPrescription/readOnlySpecialInstruction';
import { getPrescriptionNotesQuestions, WORKFLOW_TAB } from '../NewPatientUtill';
import RestorativeOptionsSummary from '../PrescriptionNotes/RestorativeOptions/RestorativeOptionsSummary';
import PreImplantAligmentSummary from '../PrescriptionNotes/PreImplantAligment/PreImplantAligmentSummary';
import { createStaticSmileDesignQuestionSchema } from '../../../pages/SmileDesign/SmileDesignQuestions';
import _ from 'lodash';

const teethGraph = [
    {
        margin: '352px 0px 0px 206px',
        width: 56,
    },
    {
        margin: '305px 0px 0px 211px',
        width: 59,
    },
    {
        margin: '253px 0px 0px 216px',
        width: 61,
    },
    {
        margin: '214px 0px 0px 230px',
        width: 59,
    },
    {
        margin: '178px 0px 0px 247px',
        width: 58,
    },
    {
        margin: '146px 0px 0px 272px',
        width: 48,
    },
    {
        margin: '118px 0px 0px 296px',
        width: 48,
    },
    {
        margin: '108px 0px 0px 328px',
        width: 49,
    },
    {
        margin: '108px 0px 0px 370px',
        deg: 'scaleX(-1)',
        width: 49,
    },
    {
        margin: '118px 0px 0px 402px',
        deg: 'scaleX(-1)',
        width: 48,
    },
    {
        margin: '146px 0px 0px 425px',
        deg: 'scaleX(-1)',
        width: 48,
    },
    {
        margin: '178px 0px 0px 444px',
        deg: 'scaleX(-1)',
        width: 58,
    },
    {
        margin: '214px 0px 0px 460px',
        deg: 'scaleX(-1)',
        width: 59,
    },
    {
        margin: '253px 0px 0px 474px',
        deg: 'scaleX(-1)',
        width: 61,
    },
    {
        margin: '305px 0px 0px 488px',
        deg: 'scaleX(-1)',
        width: 59,
    },
    {
        margin: '352px 0px 0px 497px',
        deg: 'scaleX(-1)',
        width: 56,
    },
    {
        margin: '431px 0px 0px 497px',
        deg: 'scaleX(-1) scaleY(-1)',
        width: 56,
    },
    {
        margin: '477px 0px 0px 488px',
        deg: 'scaleX(-1) scaleY(-1)',
        width: 59,
    },
    {
        margin: '523px 0px 0px 474px',
        deg: 'scaleX(-1) scaleY(-1)',
        width: 61,
    },
    {
        margin: '570px 0px 0px 460px',
        deg: 'scaleX(-1) scaleY(-1)',
        width: 59,
    },
    {
        margin: '604px 0px 0px 444px',
        deg: 'scaleX(-1) scaleY(-1)',
        width: 58,
    },
    {
        margin: '639px 0px 0px 425px',
        deg: 'scaleX(-1) scaleY(-1)',
        width: 48,
    },
    {
        margin: '663px 0px 0px 402px',
        deg: 'scaleX(-1) scaleY(-1)',
        width: 48,
    },
    {
        margin: '674px 0px 0px 370px',
        deg: 'scaleX(-1) scaleY(-1)',
        width: 49,
    },
    {
        margin: '674px 0px 0px 328px',
        deg: 'scaleY(-1)',
        width: 49,
    },
    {
        margin: '663px 0px 0px 296px',
        deg: 'scaleY(-1)',
        width: 48,
    },
    {
        margin: '639px 0px 0px 272px',
        deg: 'scaleY(-1)',
        width: 48,
    },
    {
        margin: '604px 0px 0px 247px',
        deg: 'scaleY(-1)',
        width: 59,
    },
    {
        margin: '570px 0px 0px 230px',
        deg: 'scaleY(-1)',
        width: 61,
    },
    {
        margin: '523px 0px 0px 216px',
        deg: 'scaleY(-1)',
        width: 61,
    },
    {
        margin: '477px 0px 0px 211px',
        deg: 'scaleY(-1)',
        width: 59,
    },
    {
        margin: '431px 0px 0px 206px',
        deg: 'scaleY(-1)',
        width: 58,
    },
];

class NewPatientSummary extends Component {
    getNotes = (title) => {
        return this.get(`prescriptionNotes.${title}`);
    };

    get labelIntrerpret1() {
        return getPrescriptionNotesQuestions(this.getNotes);
    }

    teeth = {
        topRight: {
            maxX: 400,
            maxY: 58,
            minX: 30,
            minY: 5,
            values: [
                { value: 0, positionX: 59, positionY: 33, boundX: 90 },
                { value: 1, positionX: 117, positionY: 33, boundX: 145 },
                { value: 2, positionX: 172, positionY: 33, boundX: 200 },
                { value: 3, positionX: 226, positionY: 33, boundX: 250 },
                { value: 4, positionX: 272, positionY: 33, boundX: 295 },
                { value: 5, positionX: 313, positionY: 33, boundX: 335 },
                { value: 6, positionX: 350, positionY: 33, boundX: 370 },
                { value: 7, positionX: 386, positionY: 33, boundX: 405 },
            ],
        },
        topLeft: {
            maxX: 780,
            maxY: 58,
            minX: 405,
            minY: 5,
            values: [
                { value: 8, positionX: 424, positionY: 33, boundX: 440 },
                { value: 9, positionX: 458, positionY: 33, boundX: 447 },
                { value: 10, positionX: 494, positionY: 33, boundX: 514 },
                { value: 11, positionX: 536, positionY: 33, boundX: 559 },
                { value: 12, positionX: 581, positionY: 33, boundX: 605 },
                { value: 13, positionX: 631, positionY: 33, boundX: 662 },
                { value: 14, positionX: 690, positionY: 33, boundX: 719 },
                { value: 15, positionX: 746, positionY: 33, boundX: 773 },
            ],
        },
        bottomRight: {
            maxX: 400,
            maxY: 170,
            minX: 30,
            minY: 125,
            values: [
                { value: 16, positionX: 60, positionY: 148, boundX: 90 },
                { value: 17, positionX: 120, positionY: 148, boundX: 145 },
                { value: 18, positionX: 174, positionY: 148, boundX: 200 },
                { value: 19, positionX: 224, positionY: 148, boundX: 250 },
                { value: 20, positionX: 272, positionY: 148, boundX: 295 },
                { value: 21, positionX: 314, positionY: 148, boundX: 335 },
                { value: 22, positionX: 348, positionY: 148, boundX: 370 },
                { value: 23, positionX: 386, positionY: 148, boundX: 405 },
            ],
        },
        bottomLeft: {
            maxX: 780,
            maxY: 170,
            minX: 405,
            minY: 125,
            values: [
                { value: 24, positionX: 420, positionY: 148, boundX: 440 },
                { value: 25, positionX: 456, positionY: 148, boundX: 447 },
                { value: 26, positionX: 493, positionY: 148, boundX: 514 },
                { value: 27, positionX: 535, positionY: 148, boundX: 559 },
                { value: 28, positionX: 582, positionY: 148, boundX: 605 },
                { value: 29, positionX: 632, positionY: 148, boundX: 662 },
                { value: 30, positionX: 690, positionY: 148, boundX: 719 },
                { value: 31, positionX: 745, positionY: 148, boundX: 773 },
            ],
        },
    };

    gainingSpaceCheckBox = [
        { name: 'crowding', label: this.get('questionnaire.crowding') },
        { name: 'deepBite', label: this.get('questionnaire.deepBite') },
        { name: 'spacing', label: this.get('questionnaire.spacing') },
        { name: 'classII', label: this.get('questionnaire.classII') },
        { name: 'ClassIIDivI', label: this.get('questionnaire.ClassIIDivI') },
        { name: 'classIII', label: this.get('questionnaire.classIII') },
        { name: 'unevenSmile', label: this.get('questionnaire.unevenSmile') },
        { name: 'openBite', label: this.get('questionnaire.openBite') },
        { name: 'overbite', label: this.get('questionnaire.overbite') },
        { name: 'other', label: this.get('questionnaire.other') },
    ];

    constructor(props) {
        super(props);
    }

    getErrorList() {
        const { NewCaseType } = this.props;
        const errors = this.props.NewPaitientData.errors || [];
        const { addOnSmileDesign } = this.props.NewPaitientData;
        const isUpSellSmileDesign = addOnSmileDesign && addOnSmileDesign?.value === 'Yes';
        let targetFilterErrIds = [];
        let errorsList = [...errors];
        switch (NewCaseType) {
            case CASE_TYPE.RETAINER:
                targetFilterErrIds = [Base_Prescription_Err.id, Base_Smile_Design_Prescription_Err.id];
                break;
            default:
                targetFilterErrIds = [Base_Retainer_Request_Err.id];
                break;
        }
        errorsList = errorsList.filter((err) => !targetFilterErrIds.includes(err.id));
        const isSmileDesignCaseType = smileDesignProductListArray.includes(NewCaseType);
        if (isSmileDesignCaseType || !isUpSellSmileDesign) {
            errorsList = errorsList.filter((err) => err.id !== Base_Smile_Design_Prescription_Err.id);
        }
        return errorsList;
    }

    getAttachmentsDelayStageLabel() {
        const match = this.labelIntrerpret1.attachmentsDelayStage.options.find(
            ({ value }) => value === this.props.attachments.delay.value
        );
        if (match) {
            return match.label;
        }
        return '';
    }

    renderUpsellSmileDesignPreview() {
        let isRenderForm = false;
        let isValid = false;
        const {
            addOnSmileDesign,
            upSellSmileDesignPrescriptionFormIsValid,
            upSellSmileDesignPrescriptionFormData,
            visitedTabs,
        } = this.props.NewPaitientData;
        const schema = createStaticSmileDesignQuestionSchema({
            isMarieGroup: this.props.isMarieGroup,
            isSEAGroup: this.props.isSEAGroup,
            isUpSellTab: true,
            displayFirstFitFlag: this.props.displayFirstFitFlag,
        });
        if (addOnSmileDesign && addOnSmileDesign?.value === 'Yes') {
            isRenderForm = true;
            isValid = upSellSmileDesignPrescriptionFormIsValid;
            // below checking is for upSellSmileDesignPrescriptionFormData is not empty but user has not clicked into Smile Design Prescription tab to trigger the validation
            if (
                !_.isEmpty(upSellSmileDesignPrescriptionFormData) &&
                !upSellSmileDesignPrescriptionFormIsValid &&
                !visitedTabs.includes(WORKFLOW_TAB.PRESCRIPTION_NOTES_UPSELL_SMILE_DESIGN)
            ) {
                isValid = schema.isValidSync(upSellSmileDesignPrescriptionFormData);
            }
        }
        if (!isRenderForm)
            return (
                <div>
                    <p>{this.get('@NewPatient.prescriptionNotes.addOnSmileDesign')}</p>
                    <p>{this.get('@global.const.no')}</p>
                </div>
            );
        return isValid ? (
            <SmileDesignPrescriptionNotesPreview
                defaultValues={upSellSmileDesignPrescriptionFormData}
                schema={schema}
                isMarieGroup={this.props.isMarieGroup}
                isSEAGroup={this.props.isSEAGroup}
                isUpsellTab={true}
            />
        ) : (
            <div style={{ color: 'red' }}>{this.get('@NewPatient.smileDesignNotCompleted')}</div>
        );
    }

    renderUpsellPartInSummary() {
        const { allowedFeatures } = this.props.userAllowedFeatures || {};
        if (allowedFeatures?.smile_design) return true;
        return false;
    }

    /**
     * Returns the starting number for impressions list
     *
     * Prescription structure:
     * - Items 1-16: Basic prescription (arch, attachments, spacing, etc.)
     * - Item 17: Special instructions
     * - Items 18+: Impressions start here
     *
     * Case type handling:
     * - Retainer: Start at 1 (no prescription items)
     * - Smile Design: Start at 1 (separate numbering)
     * - Aligner(with upsell part): Start at 18 (after 17 prescription items)
     * - Aligner: Start at 15 (basic prescription items only)
     * ⚠️ Update return value when prescription questions are added/removed
     */
    getOlStartNumber() {
        const { NewCaseType } = this.props;
        if (NewCaseType === CASE_TYPE.RETAINER) return 1;
        if (smileDesignProductListArray.includes(NewCaseType)) return 1;
        if (this.renderUpsellPartInSummary()) return 18;
        return 15;
    }

    render() {
        let { NewCaseType } = this.props;
        let { diffRetainer, NewPaitientData } = this.props;
        const retainerRequestformValue = NewPaitientData.retainerRequestPrescriptionNote;
        const supportedRetainerTypes = diffRetainer.supportedRetainerTypes;
        const retainerRequestPrescriptionNote = getPrescriptionValue(retainerRequestformValue, supportedRetainerTypes);
        return (
            <Grid container spacing={3}>
                {NewCaseType !== CASE_TYPE.SELF_DESIGN && (
                <Grid item xs={12} sm={8}>
                    <div className={style.LeftGrid} style={{ width: '100%' }}>
                        {NewCaseType !== 'RETAINER' && !smileDesignProductListArray.includes(NewCaseType) && NewCaseType !== CASE_TYPE.SELF_DESIGN && (
                            <>
                                <ol className={style.list}>
                                    <li>{this.getNotes('archToTreat')}</li>
                                    <p>
                                        {questionFiliter(
                                            this.labelIntrerpret1.archToTreat.options,
                                            this.props.archToTreat
                                        )}
                                    </p>
                                    <br />
                                    {this.getNotes('excludedDentition') &&
                                    this.getNotes('excludedDentition').includes('NOT') ? (
                                        <li>
                                            {this.getNotes('excludedDentition').split('NOT')[0]}
                                            <span className={[style.redText, style.underline].join(' ')}>NOT</span>
                                            {this.getNotes('excludedDentition').split('NOT')[1]}
                                        </li>
                                    ) : (
                                        <li>{this.getNotes('excludedDentition')}</li>
                                    )}

                                    <div className={style.toothImages}>
                                        <div
                                            style={{
                                                width: 800,
                                                height: 200,
                                                'margin-top': '10px',
                                                position: 'relative',
                                                backgroundRepeat: 'no-repeat',
                                                backgroundImage: `url("${getWebAbsPath('/img/prescriptionNotes/smaller_teeth_number_CS.ai.png')}")`,
                                            }}
                                        >
                                            {this.props.notToTreat.map((toothValue) => {
                                                for (let [_, objValue] of Object.entries(this.teeth)) {
                                                    for (let { value, positionX, positionY } of objValue.values) {
                                                        if (value === toothValue) {
                                                            return (
                                                                <img
                                                                    src={getWebAbsPath(
                                                                        '/img/prescriptionNotes/checkFail.png'
                                                                    )}
                                                                    alt="checked"
                                                                    style={{
                                                                        position: 'absolute',
                                                                        top: positionY - 10,
                                                                        left: positionX - 12,
                                                                        userSelect: 'none',
                                                                    }}
                                                                />
                                                            );
                                                        }
                                                    }
                                                }
                                            })}
                                        </div>
                                    </div>

                                    <li>{this.labelIntrerpret1.attachments.label}</li>
                                    {questionFiliter1(
                                        this.labelIntrerpret1.attachments.options,
                                        this.props.attachments.value
                                    ).includes('NOT') ? (
                                        <p>
                                            {
                                                questionFiliter1(
                                                    this.labelIntrerpret1.attachments.options,
                                                    this.props.attachments.value
                                                ).split('NOT')[0]
                                            }
                                            <span className={[style.redText, style.underline].join(' ')}>NOT</span>
                                            {
                                                questionFiliter1(
                                                    this.labelIntrerpret1.attachments.options,
                                                    this.props.attachments.value
                                                ).split('NOT')[1]
                                            }
                                        </p>
                                    ) : (
                                        <p>
                                            {questionFiliter1(
                                                this.labelIntrerpret1.attachments.options,
                                                this.props.attachments.value
                                            )}
                                        </p>
                                    )}

                                    {this.props.attachments.value === 'includedExcludedAttachments' ? (
                                        <>
                                            {this.getNotes('excludedAttachments')}
                                            <div className={style.toothImages}>
                                                <div
                                                    style={{
                                                        width: 800,
                                                        height: 200,
                                                        'margin-top': '10px',
                                                        position: 'relative',
                                                        backgroundRepeat: 'no-repeat',
                                                        backgroundImage: `url("${getWebAbsPath('/img/prescriptionNotes/smaller_teeth_number_CS.ai.png')}")`,
                                                    }}
                                                >
                                                    {this.props.attachments.doNotPlace.map((toothValue) => {
                                                        for (let [_, objValue] of Object.entries(this.teeth)) {
                                                            for (let {
                                                                value,
                                                                positionX,
                                                                positionY,
                                                            } of objValue.values) {
                                                                if (value === toothValue) {
                                                                    return (
                                                                        <img
                                                                            src={getWebAbsPath(
                                                                                '/img/prescriptionNotes/checkFail.png'
                                                                            )}
                                                                            alt="checked"
                                                                            style={{
                                                                                position: 'absolute',
                                                                                top: positionY - 10,
                                                                                left: positionX - 12,
                                                                                userSelect: 'none',
                                                                            }}
                                                                        />
                                                                    );
                                                                }
                                                            }
                                                        }
                                                    })}
                                                </div>
                                            </div>
                                        </>
                                    ) : null}
                                    {this.props.attachments.value === 'includedExcludedAttachments' ? (
                                        <>
                                            {this.getNotes('includedAttachments')}
                                            <div className={style.toothImages}>
                                                <div
                                                    style={{
                                                        width: 800,
                                                        height: 200,
                                                        'margin-top': '10px',
                                                        position: 'relative',
                                                        backgroundRepeat: 'no-repeat',
                                                        backgroundImage: `url("${getWebAbsPath('/img/prescriptionNotes/smaller_teeth_number_CS.ai.png')}")`,
                                                    }}
                                                >
                                                    {this.props.attachments.place.map((toothValue) => {
                                                        for (let [_, objValue] of Object.entries(this.teeth)) {
                                                            for (let {
                                                                value,
                                                                positionX,
                                                                positionY,
                                                            } of objValue.values) {
                                                                if (value === toothValue) {
                                                                    return (
                                                                        <img
                                                                            src={getWebAbsPath(
                                                                                '/img/prescriptionNotes/checkSuccess.png'
                                                                            )}
                                                                            alt="checked"
                                                                            style={{
                                                                                position: 'absolute',
                                                                                top: positionY - 10,
                                                                                left: positionX - 12,
                                                                                userSelect: 'none',
                                                                            }}
                                                                        />
                                                                    );
                                                                }
                                                            }
                                                        }
                                                    })}
                                                </div>
                                            </div>
                                        </>
                                    ) : null}
                                    <p>{this.labelIntrerpret1.attachmentsDelayStage.label}</p>
                                    <p>
                                        {this.getAttachmentsDelayStageLabel()}
                                        {this.props.attachments.delay.stage ? (
                                            <>:&nbsp;{this.props.attachments.delay.stage}</>
                                        ) : (
                                            ''
                                        )}
                                    </p>
                                    <br />
                                    <li>{this.labelIntrerpret1.alignersMarginPlacement.label}</li>
                                    <p>
                                        {questionFiliter(
                                            this.labelIntrerpret1.alignersMarginPlacement.options,
                                            this.props.alignersMarginPlacement
                                        )}
                                    </p>
                                    <br />
                                    <li>{this.labelIntrerpret1.anteriorPosteriorRelationship.label}&nbsp;&nbsp;</li>
                                    <p>
                                        {this.getNotes('right')}:{' '}
                                        {questionFiliter(
                                            this.labelIntrerpret1.anteriorPosteriorRelationship.options,
                                            this.props.anteriorPosteriorRelationship.r
                                        )}
                                        <br />
                                    </p>
                                    <p>
                                        {this.getNotes('left')}:{' '}
                                        {questionFiliter(
                                            this.labelIntrerpret1.anteriorPosteriorRelationship.options,
                                            this.props.anteriorPosteriorRelationship.l
                                        )}
                                        <br />
                                    </p>
                                    <br />
                                    <li>{this.labelIntrerpret1.spacingAndCrowding.label}</li>
                                    <p>
                                        <FormLabel className={style.subtitle1}>
                                            {this.labelIntrerpret1.spacingAndCrowding.options[0].label}
                                        </FormLabel>
                                    </p>

                                    <p>
                                        &emsp;
                                        {questionFiliter(
                                            this.labelIntrerpret1.spacingAndCrowding.options[0].options,
                                            this.props.spacingAndCrowding.spacing.value
                                        )}
                                        {this.props.spacingAndCrowding.spacing.location ? (
                                            <>
                                                : {this.props.spacingAndCrowding.spacing.location}
                                                <br />
                                            </>
                                        ) : (
                                            <br />
                                        )}
                                    </p>
                                    <br />
                                    <p>
                                        <FormLabel className={style.subtitle1}>
                                            {this.labelIntrerpret1.spacingAndCrowding.options[1].label}
                                        </FormLabel>
                                    </p>

                                    <p>
                                        &emsp;
                                        <FormLabel className={style.minititle}>
                                            {this.labelIntrerpret1.spacingAndCrowding.options[1].options[0].label}
                                        </FormLabel>
                                    </p>
                                    <p className={style.subtitle}>
                                        {
                                            this.labelIntrerpret1.spacingAndCrowding.options[1].options[0].options[0]
                                                .label
                                        }
                                        :
                                        {this.getNotes(
                                            this.props.spacingAndCrowding.crowding.resolveUpper.expand.value
                                        )}
                                        {this.props.spacingAndCrowding.crowding.resolveUpper.expand.teeth
                                            ? ` (${this.props.spacingAndCrowding.crowding.resolveUpper.expand.teeth})`
                                            : null}
                                    </p>
                                    <p className={style.subtitle}>
                                        {
                                            this.labelIntrerpret1.spacingAndCrowding.options[1].options[0].options[1]
                                                .label
                                        }
                                        :{' '}
                                        {this.getNotes(
                                            this.props.spacingAndCrowding.crowding.resolveUpper.procline.value
                                        )}
                                        {this.props.spacingAndCrowding.crowding.resolveUpper.procline.teeth
                                            ? ` (${this.props.spacingAndCrowding.crowding.resolveUpper.procline.teeth})`
                                            : null}
                                    </p>
                                    <p className={style.subtitle}>
                                        {
                                            this.labelIntrerpret1.spacingAndCrowding.options[1].options[0].options[2]
                                                .label
                                        }
                                        :{' '}
                                        {this.getNotes(
                                            this.props.spacingAndCrowding.crowding.resolveUpper.IPRAnterior.value
                                        )}
                                        {this.props.spacingAndCrowding.crowding.resolveUpper.IPRAnterior.teeth
                                            ? ` (${this.props.spacingAndCrowding.crowding.resolveUpper.IPRAnterior.teeth})`
                                            : null}
                                    </p>
                                    <p className={style.subtitle}>
                                        {
                                            this.labelIntrerpret1.spacingAndCrowding.options[1].options[0].options[3]
                                                .label
                                        }
                                        :{' '}
                                        {this.getNotes(
                                            this.props.spacingAndCrowding.crowding.resolveUpper.IPRPosteriorRight.value
                                        )}
                                        {this.props.spacingAndCrowding.crowding.resolveUpper.IPRPosteriorRight.teeth
                                            ? ` (${this.props.spacingAndCrowding.crowding.resolveUpper.IPRPosteriorRight.teeth})`
                                            : null}
                                    </p>
                                    <p className={style.subtitle}>
                                        {
                                            this.labelIntrerpret1.spacingAndCrowding.options[1].options[0].options[4]
                                                .label
                                        }
                                        :{' '}
                                        {this.getNotes(
                                            this.props.spacingAndCrowding.crowding.resolveUpper.IPRPosteriorLeft.value
                                        )}
                                        {this.props.spacingAndCrowding.crowding.resolveUpper.IPRPosteriorLeft.teeth
                                            ? ` (${this.props.spacingAndCrowding.crowding.resolveUpper.IPRPosteriorLeft.teeth})`
                                            : null}
                                    </p>
                                    <p className={style.subtitle}>
                                        {
                                            this.labelIntrerpret1.spacingAndCrowding.options[1].options[0].options[5]
                                                .label
                                        }
                                        :{' '}
                                        {this.getNotes(
                                            this.props.spacingAndCrowding.crowding.resolveUpper.extraction.value
                                        )}
                                        {this.props.spacingAndCrowding.crowding.resolveUpper.extraction.teeth
                                            ? ` (${this.props.spacingAndCrowding.crowding.resolveUpper.extraction.teeth})`
                                            : null}
                                    </p>
                                    <br />
                                    <p>
                                        &emsp;
                                        <FormLabel className={style.minititle}>
                                            {this.labelIntrerpret1.spacingAndCrowding.options[1].options[1].label}
                                        </FormLabel>
                                    </p>
                                    <p className={style.subtitle}>
                                        {
                                            this.labelIntrerpret1.spacingAndCrowding.options[1].options[1].options[0]
                                                .label
                                        }
                                        :{' '}
                                        {this.getNotes(
                                            this.props.spacingAndCrowding.crowding.resolveLower.expand.value
                                        )}
                                        {this.props.spacingAndCrowding.crowding.resolveLower.expand.teeth
                                            ? ` (${this.props.spacingAndCrowding.crowding.resolveLower.expand.teeth})`
                                            : null}
                                    </p>
                                    <p className={style.subtitle}>
                                        {
                                            this.labelIntrerpret1.spacingAndCrowding.options[1].options[1].options[1]
                                                .label
                                        }
                                        :{' '}
                                        {this.getNotes(
                                            this.props.spacingAndCrowding.crowding.resolveLower.procline.value
                                        )}
                                        {this.props.spacingAndCrowding.crowding.resolveLower.procline.teeth
                                            ? ` (${this.props.spacingAndCrowding.crowding.resolveLower.procline.teeth})`
                                            : null}
                                    </p>
                                    <p className={style.subtitle}>
                                        {
                                            this.labelIntrerpret1.spacingAndCrowding.options[1].options[1].options[2]
                                                .label
                                        }
                                        :{' '}
                                        {this.getNotes(
                                            this.props.spacingAndCrowding.crowding.resolveLower.IPRAnterior.value
                                        )}
                                        {this.props.spacingAndCrowding.crowding.resolveLower.IPRAnterior.teeth
                                            ? ` (${this.props.spacingAndCrowding.crowding.resolveLower.IPRAnterior.teeth})`
                                            : null}
                                    </p>
                                    <p className={style.subtitle}>
                                        {
                                            this.labelIntrerpret1.spacingAndCrowding.options[1].options[1].options[3]
                                                .label
                                        }
                                        :{' '}
                                        {this.getNotes(
                                            this.props.spacingAndCrowding.crowding.resolveLower.IPRPosteriorRight.value
                                        )}
                                        {this.props.spacingAndCrowding.crowding.resolveLower.IPRPosteriorRight.teeth
                                            ? ` (${this.props.spacingAndCrowding.crowding.resolveLower.IPRPosteriorRight.teeth})`
                                            : null}
                                    </p>
                                    <p className={style.subtitle}>
                                        {
                                            this.labelIntrerpret1.spacingAndCrowding.options[1].options[1].options[4]
                                                .label
                                        }
                                        :{' '}
                                        {this.getNotes(
                                            this.props.spacingAndCrowding.crowding.resolveLower.IPRPosteriorLeft.value
                                        )}
                                        {this.props.spacingAndCrowding.crowding.resolveLower.IPRPosteriorLeft.teeth
                                            ? ` (${this.props.spacingAndCrowding.crowding.resolveLower.IPRPosteriorLeft.teeth})`
                                            : null}
                                    </p>
                                    <p className={style.subtitle}>
                                        {
                                            this.labelIntrerpret1.spacingAndCrowding.options[1].options[1].options[5]
                                                .label
                                        }
                                        :{' '}
                                        {this.getNotes(
                                            this.props.spacingAndCrowding.crowding.resolveLower.extraction.value
                                        )}
                                        {this.props.spacingAndCrowding.crowding.resolveLower.extraction.teeth
                                            ? ` (${this.props.spacingAndCrowding.crowding.resolveLower.extraction.teeth})`
                                            : null}
                                    </p>
                                    <br />
                                    <li>{this.labelIntrerpret1.overjet.label}</li>
                                    <p>
                                        {questionFiliter(
                                            this.labelIntrerpret1.overjet.options,
                                            this.props.overJet.value
                                        )}
                                    </p>
                                    {this.props.overJet.subValue ? (
                                        <>
                                            <p>
                                                &emsp;
                                                {questionFiliter(
                                                    this.labelIntrerpret1.overjet.options[1].options,
                                                    this.props.overJet.subValue
                                                )}
                                            </p>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                </ol>
                                <ol className={style.list} start={8}>
                                    <li>{this.labelIntrerpret1.openbite.label}</li>
                                    <p>
                                        {questionFiliter(
                                            this.labelIntrerpret1.openbite.options,
                                            this.props.openbite.value
                                        )}
                                    </p>
                                    {this.props.openbite.subValue.value ? (
                                        <>
                                            <p>
                                                &emsp;
                                                {questionFiliter(
                                                    this.labelIntrerpret1.openbite.options[1].options,
                                                    this.props.openbite.subValue.value
                                                )}
                                            </p>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    {this.props.openbite.subValue.extrudeAnteriorTeeth.value ? (
                                        <>
                                            <p>
                                                &emsp;
                                                {checkBoxAssociated(
                                                    this.labelIntrerpret1.openbite.options[1].options[1].label,
                                                    this.props.openbite.subValue.extrudeAnteriorTeeth.value
                                                )}
                                                :{' '}
                                            </p>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    {this.props.openbite.subValue.extrudeAnteriorTeeth.upper ? (
                                        <>
                                            <p>
                                                &emsp;&emsp;
                                                {checkBoxAssociated(
                                                    this.labelIntrerpret1.openbite.options[1].options[1].options[0]
                                                        .label,
                                                    this.props.openbite.subValue.extrudeAnteriorTeeth.upper
                                                )}
                                            </p>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    {this.props.openbite.subValue.extrudeAnteriorTeeth.lower ? (
                                        <>
                                            <p>
                                                &emsp;&emsp;
                                                {checkBoxAssociated(
                                                    this.labelIntrerpret1.openbite.options[1].options[1].options[1]
                                                        .label,
                                                    this.props.openbite.subValue.extrudeAnteriorTeeth.lower
                                                )}
                                            </p>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    {this.props.openbite.subValue.intrudePosteriorTeeth.value ? (
                                        <>
                                            <p>
                                                &emsp;
                                                {checkBoxAssociated(
                                                    this.labelIntrerpret1.openbite.options[1].options[2].label,
                                                    this.props.openbite.subValue.intrudePosteriorTeeth.value
                                                )}
                                                :{' '}
                                            </p>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    {this.props.openbite.subValue.intrudePosteriorTeeth.upper ? (
                                        <>
                                            <p>
                                                &emsp;&emsp;
                                                {checkBoxAssociated(
                                                    this.labelIntrerpret1.openbite.options[1].options[2].options[0]
                                                        .label,
                                                    this.props.openbite.subValue.intrudePosteriorTeeth.upper
                                                )}{' '}
                                            </p>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    {this.props.openbite.subValue.intrudePosteriorTeeth.lower ? (
                                        <>
                                            <p>
                                                &emsp;&emsp;
                                                {checkBoxAssociated(
                                                    this.labelIntrerpret1.openbite.options[1].options[2].options[1]
                                                        .label,
                                                    this.props.openbite.subValue.intrudePosteriorTeeth.lower
                                                )}
                                            </p>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    {this.props.openbite.subValue.placeMiniImplantsTAD.value ? (
                                        <>
                                            <p>
                                                &emsp;
                                                {checkBoxAssociated(
                                                    this.labelIntrerpret1.openbite.options[1].options[3].label,
                                                    this.props.openbite.subValue.placeMiniImplantsTAD.value,
                                                    this.props.openbite.subValue?.placeMiniImplantsTAD?.input || null
                                                )}
                                            </p>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    <br />
                                    <li>{this.labelIntrerpret1.deepBite.label}</li>
                                    <p>
                                        {questionFiliter(
                                            this.labelIntrerpret1.deepBite.options,
                                            this.props.deepBite.value
                                        )}
                                    </p>
                                    {this.props.deepBite.subValue.value ? (
                                        <>
                                            <p>
                                                &emsp;
                                                {questionFiliter(
                                                    this.labelIntrerpret1.deepBite.options[1].options,
                                                    this.props.deepBite.subValue.value
                                                )}
                                            </p>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    {this.props.deepBite.subValue.intrudeAnteriorTeeth.value ? (
                                        <>
                                            <p>
                                                &emsp;
                                                {checkBoxAssociated(
                                                    this.labelIntrerpret1.deepBite.options[1].options[1].label,
                                                    this.props.deepBite.subValue.intrudeAnteriorTeeth.value
                                                )}
                                                :{' '}
                                            </p>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    {this.props.deepBite.subValue.intrudeAnteriorTeeth.upper ? (
                                        <>
                                            <p>
                                                &emsp;&emsp;
                                                {checkBoxAssociated(
                                                    this.labelIntrerpret1.deepBite.options[1].options[1].options[0]
                                                        .label,
                                                    this.props.deepBite.subValue.intrudeAnteriorTeeth.upper
                                                )}
                                            </p>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    {this.props.deepBite.subValue.intrudeAnteriorTeeth.lower ? (
                                        <>
                                            <p>
                                                &emsp;&emsp;
                                                {checkBoxAssociated(
                                                    this.labelIntrerpret1.deepBite.options[1].options[1].options[1]
                                                        .label,
                                                    this.props.deepBite.subValue.intrudeAnteriorTeeth.lower
                                                )}
                                            </p>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    {this.props.deepBite.subValue.extrudePosteriorTeeth.value ? (
                                        <>
                                            <p>
                                                &emsp;
                                                {checkBoxAssociated(
                                                    this.labelIntrerpret1.deepBite.options[1].options[2].label,
                                                    this.props.deepBite.subValue.extrudePosteriorTeeth.value
                                                )}
                                                :{' '}
                                            </p>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    {this.props.deepBite.subValue.extrudePosteriorTeeth.upper ? (
                                        <>
                                            <p>
                                                &emsp;&emsp;
                                                {checkBoxAssociated(
                                                    this.labelIntrerpret1.deepBite.options[1].options[2].options[0]
                                                        .label,
                                                    this.props.deepBite.subValue.extrudePosteriorTeeth.upper
                                                )}
                                            </p>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    {this.props.deepBite.subValue.extrudePosteriorTeeth.lower ? (
                                        <>
                                            <p>
                                                &emsp;&emsp;
                                                {checkBoxAssociated(
                                                    this.labelIntrerpret1.deepBite.options[1].options[2].options[1]
                                                        .label,
                                                    this.props.deepBite.subValue.extrudePosteriorTeeth.lower
                                                )}
                                            </p>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    {this.props.deepBite.subValue.placeMiniImplantsTAD.value ? (
                                        <>
                                            <p>
                                                &emsp;
                                                {checkBoxAssociated(
                                                    this.labelIntrerpret1.deepBite.options[1].options[3].label,
                                                    this.props.deepBite.subValue.placeMiniImplantsTAD.value,
                                                    this.props.deepBite.subValue?.placeMiniImplantsTAD?.input || null
                                                )}
                                            </p>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    <br />
                                    <p>{this.getNotes('deepBiteRemark')}</p>
                                    <br />
                                    <li>{this.labelIntrerpret1.midline.label}</li>
                                    <p>
                                        {questionFiliter(
                                            this.labelIntrerpret1.midline.options,
                                            this.props.midline.value
                                        )}
                                    </p>
                                    {this.props.midline.subValue.value ? (
                                        <>
                                            <p>
                                                &emsp;
                                                {questionFiliter(
                                                    this.labelIntrerpret1.midline.options[1].options,
                                                    this.props.midline.subValue.value
                                                )}
                                            </p>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    {this.props.midline.subValue.upper.checked ? (
                                        <>
                                            <p>
                                                &emsp;
                                                {checkBoxAssociated(
                                                    this.labelIntrerpret1.midline.options[1].options[1].label,
                                                    this.props.midline.subValue.upper.checked
                                                )}
                                                :{' '}
                                                {questionFiliter(
                                                    this.labelIntrerpret1.midline.options[1].options[1].options,
                                                    this.props.midline.subValue.upper.value
                                                )}
                                            </p>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    {this.props.midline.subValue.lower.checked ? (
                                        <>
                                            <p>
                                                &emsp;
                                                {checkBoxAssociated(
                                                    this.labelIntrerpret1.midline.options[1].options[2].label,
                                                    this.props.midline.subValue.lower.checked
                                                )}
                                                :{' '}
                                                {questionFiliter(
                                                    this.labelIntrerpret1.midline.options[1].options[2].options,
                                                    this.props.midline.subValue.lower.value
                                                )}
                                            </p>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    <br />
                                    <li>{this.labelIntrerpret1.posteriorCrossbite.label}</li>
                                    <p>
                                        {questionFiliter(
                                            this.labelIntrerpret1.posteriorCrossbite.options,
                                            this.props.posteriorCrossbite.value
                                        )}
                                    </p>
                                    {this.props.posteriorCrossbite.subValue.value ? (
                                        <>
                                            <p>
                                                &emsp;
                                                {questionFiliter(
                                                    this.labelIntrerpret1.posteriorCrossbite.options[1].options,
                                                    this.props.posteriorCrossbite.subValue.value
                                                )}
                                                {this.props.posteriorCrossbite.subValue.value === 'otherMethods'
                                                    ? this.props.posteriorCrossbite.subValue.subValue.otherMethod
                                                    : ''}
                                            </p>
                                        </>
                                    ) : (
                                        <></>
                                    )}

                                    {this.props.posteriorCrossbite.subValue.subValue.value ? (
                                        questionFiliter1(
                                            this.labelIntrerpret1.posteriorCrossbite.options[1].options[1].options,
                                            this.props.posteriorCrossbite.subValue.subValue.value
                                        ) &&
                                        questionFiliter1(
                                            this.labelIntrerpret1.posteriorCrossbite.options[1].options[1].options,
                                            this.props.posteriorCrossbite.subValue.subValue.value
                                        ).includes('2nd') ? (
                                            <>
                                                <p>
                                                    &emsp;&emsp;
                                                    {
                                                        questionFiliter1(
                                                            this.labelIntrerpret1.posteriorCrossbite.options[1]
                                                                .options[1].options,
                                                            this.props.posteriorCrossbite.subValue.subValue.value
                                                        ).split('2nd')[0]
                                                    }
                                                    2<sup>nd</sup>
                                                    {
                                                        questionFiliter1(
                                                            this.labelIntrerpret1.posteriorCrossbite.options[1]
                                                                .options[1].options,
                                                            this.props.posteriorCrossbite.subValue.subValue.value
                                                        ).split('2nd')[1]
                                                    }
                                                </p>
                                            </>
                                        ) : (
                                            <>
                                                <p>
                                                    &emsp;&emsp;
                                                    {questionFiliter(
                                                        this.labelIntrerpret1.posteriorCrossbite.options[1].options[1]
                                                            .options,
                                                        this.props.posteriorCrossbite.subValue.subValue.value
                                                    )}
                                                </p>
                                            </>
                                        )
                                    ) : (
                                        <></>
                                    )}
                                    {this.props.posteriorCrossbite.subValue.subValue.buttonPressedDirectlyOnAligner
                                        .maxillaryTeeth ? (
                                        <>
                                            <p>
                                                &emsp;&emsp;&emsp;
                                                {checkBoxAssociated(
                                                    this.labelIntrerpret1.posteriorCrossbite.options[1].options[1]
                                                        .options[0].options[0].label,
                                                    this.props.posteriorCrossbite.subValue.subValue
                                                        .buttonPressedDirectlyOnAligner.maxillaryTeeth
                                                )}
                                            </p>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    {this.props.posteriorCrossbite.subValue.subValue.buttonPressedDirectlyOnAligner
                                        .mandibularTeeth ? (
                                        <>
                                            <p>
                                                &emsp;&emsp;&emsp;
                                                {checkBoxAssociated(
                                                    this.labelIntrerpret1.posteriorCrossbite.options[1].options[1]
                                                        .options[0].options[1].label,
                                                    this.props.posteriorCrossbite.subValue.subValue
                                                        .buttonPressedDirectlyOnAligner.mandibularTeeth
                                                )}
                                            </p>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    {this.props.posteriorCrossbite.subValue.subValue.cutoutToBondButtonDirectlyOnTeeth
                                        .maxillaryTeeth ? (
                                        <>
                                            <p>
                                                &emsp;&emsp;&emsp;
                                                {checkBoxAssociated(
                                                    this.labelIntrerpret1.posteriorCrossbite.options[1].options[1]
                                                        .options[1].options[0].label,
                                                    this.props.posteriorCrossbite.subValue.subValue
                                                        .cutoutToBondButtonDirectlyOnTeeth.maxillaryTeeth
                                                )}
                                            </p>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    {this.props.posteriorCrossbite.subValue.subValue.cutoutToBondButtonDirectlyOnTeeth
                                        .mandibularTeeth ? (
                                        <>
                                            <p>
                                                &emsp;&emsp;&emsp;
                                                {checkBoxAssociated(
                                                    this.labelIntrerpret1.posteriorCrossbite.options[1].options[1]
                                                        .options[1].options[1].label,
                                                    this.props.posteriorCrossbite.subValue.subValue
                                                        .cutoutToBondButtonDirectlyOnTeeth.mandibularTeeth
                                                )}
                                            </p>
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                    <br />
                                    <li>{this.labelIntrerpret1.auxiliaries.label}</li>
                                    <p style={{ fontWeight: 'bold' }}>
                                        {this.labelIntrerpret1.auxiliaries.options[0].label}
                                    </p>
                                    <ol type="i">
                                        <li style={{ padding: 0 }}>
                                            <p>
                                                {this.labelIntrerpret1.auxiliaries.options[0].options[0].label}:{' '}
                                                {questionFiliter(
                                                    this.labelIntrerpret1.auxiliaries.options[0].options[0].options,
                                                    this.props.auxiliaries.classIIElastics
                                                )}
                                            </p>
                                        </li>
                                        <li style={{ padding: 0 }}>
                                            <p>
                                                {this.labelIntrerpret1.auxiliaries.options[0].options[1].label}:{' '}
                                                {questionFiliter(
                                                    this.labelIntrerpret1.auxiliaries.options[0].options[1].options,
                                                    this.props.auxiliaries.classIIIElastics
                                                )}
                                            </p>
                                        </li>
                                        {this.props.auxiliaries.classIIElastics === 'Yes' ||
                                        this.props.auxiliaries.classIIIElastics === 'Yes' ? (
                                            <>
                                                <p>
                                                    &emsp;
                                                    {this.labelIntrerpret1.auxiliaries.options[0].options[2].label}
                                                </p>
                                                <p>
                                                    &emsp;
                                                    <u>
                                                        {
                                                            this.labelIntrerpret1.auxiliaries.options[0].options[2]
                                                                .options[0].label
                                                        }
                                                        :{' '}
                                                    </u>
                                                </p>
                                                <p>
                                                    &emsp;&emsp;
                                                    {questionFiliter(
                                                        this.labelIntrerpret1.auxiliaries.options[0].options[2]
                                                            .options[0].options,
                                                        this.props.auxiliaries.subValue.upper.value
                                                    )}
                                                </p>
                                                <p>
                                                    &emsp;
                                                    <u>
                                                        {
                                                            this.labelIntrerpret1.auxiliaries.options[0].options[2]
                                                                .options[1].label
                                                        }
                                                        :{' '}
                                                    </u>
                                                </p>
                                                <p>
                                                    &emsp;&emsp;
                                                    {questionFiliter(
                                                        this.labelIntrerpret1.auxiliaries.options[0].options[2]
                                                            .options[1].options,
                                                        this.props.auxiliaries.subValue.lower.value
                                                    )}
                                                </p>
                                            </>
                                        ) : (
                                            ''
                                        )}

                                        {this.props.auxiliaries.subValue.upper.upperFabricate ||
                                        this.props.auxiliaries.subValue.upper.upperCutout ||
                                        this.props.auxiliaries.subValue.upper.upperSlipCut ? (
                                            <>
                                                <p>
                                                    &emsp;
                                                    <u>
                                                        {
                                                            this.labelIntrerpret1.auxiliaries.options[0].options[2]
                                                                .options[0].label
                                                        }
                                                        :{' '}
                                                    </u>
                                                </p>
                                                {this.props.auxiliaries.subValue.upper.upperFabricate ? (
                                                    <>
                                                        <p>
                                                            &emsp;&emsp;
                                                            {checkBoxAssociated(
                                                                this.labelIntrerpret1.auxiliaries.options[0].options[2]
                                                                    .options[0].options[0].label,
                                                                this.props.auxiliaries.subValue.upper.upperFabricate
                                                            )}
                                                        </p>
                                                    </>
                                                ) : (
                                                    <></>
                                                )}
                                                {this.props.auxiliaries.subValue.upper.upperCutout ? (
                                                    <>
                                                        <p>
                                                            &emsp;&emsp;
                                                            {checkBoxAssociated(
                                                                this.labelIntrerpret1.auxiliaries.options[0].options[2]
                                                                    .options[0].options[1].label,
                                                                this.props.auxiliaries.subValue.upper.upperCutout
                                                            )}
                                                        </p>
                                                    </>
                                                ) : (
                                                    <></>
                                                )}
                                                {this.props.auxiliaries.subValue.upper.upperSlipCut ? (
                                                    <>
                                                        <p>
                                                            &emsp;&emsp;
                                                            {checkBoxAssociated(
                                                                this.labelIntrerpret1.auxiliaries.options[0].options[2]
                                                                    .options[0].options[2].label,
                                                                this.props.auxiliaries.subValue.upper.upperSlipCut
                                                            )}
                                                        </p>
                                                    </>
                                                ) : (
                                                    <></>
                                                )}
                                            </>
                                        ) : null}

                                        {this.props.auxiliaries.subValue.lower.lowerFabricate ||
                                        this.props.auxiliaries.subValue.lower.lowerCutout ||
                                        this.props.auxiliaries.subValue.lower.lowerSlipCut ? (
                                            <>
                                                <p>
                                                    &emsp;
                                                    <u>
                                                        {
                                                            this.labelIntrerpret1.auxiliaries.options[0].options[2]
                                                                .options[1].label
                                                        }
                                                        :{' '}
                                                    </u>
                                                </p>
                                                {this.props.auxiliaries.subValue.lower.lowerFabricate ? (
                                                    <>
                                                        <p>
                                                            &emsp;&emsp;
                                                            {checkBoxAssociated(
                                                                this.labelIntrerpret1.auxiliaries.options[0].options[2]
                                                                    .options[1].options[0].label,
                                                                this.props.auxiliaries.subValue.lower.lowerFabricate
                                                            )}
                                                        </p>
                                                    </>
                                                ) : (
                                                    <></>
                                                )}
                                                {this.props.auxiliaries.subValue.lower.lowerCutout ? (
                                                    <>
                                                        <p>
                                                            &emsp;&emsp;
                                                            {checkBoxAssociated(
                                                                this.labelIntrerpret1.auxiliaries.options[0].options[2]
                                                                    .options[1].options[1].label,
                                                                this.props.auxiliaries.subValue.lower.lowerCutout
                                                            )}
                                                        </p>
                                                    </>
                                                ) : (
                                                    <></>
                                                )}
                                                {this.props.auxiliaries.subValue.lower.lowerSlipCut ? (
                                                    <>
                                                        <p>
                                                            &emsp;&emsp;
                                                            {checkBoxAssociated(
                                                                this.labelIntrerpret1.auxiliaries.options[0].options[2]
                                                                    .options[1].options[2].label,
                                                                this.props.auxiliaries.subValue.lower.lowerSlipCut
                                                            )}
                                                        </p>
                                                    </>
                                                ) : (
                                                    <></>
                                                )}
                                            </>
                                        ) : null}

                                        <li style={{ padding: 0 }}>
                                            <p>{this.labelIntrerpret1.auxiliaries.options[0].options[3].label}: </p>
                                            {this.props.auxiliaries.otherElastics.comment ? (
                                                <p>
                                                    {this.getNotes('yes') +
                                                        ': ' +
                                                        this.props.auxiliaries.otherElastics.comment}
                                                </p>
                                            ) : (
                                                <p>{this.getNotes('no')}</p>
                                            )}
                                        </li>
                                    </ol>

                                    <br />
                                    <li>{this.labelIntrerpret1.trioDimForce.label}</li>
                                    <p>{this.getNotes(`trioDimForce_${this.props.trioDimForce}`)}</p>

                                    {this.renderUpsellPartInSummary() && (
                                        <>
                                            <br />
                                            <RestorativeOptionsSummary
                                                restorativeOptions={this.props.restorativeOptions}
                                                label={<li>{this.labelIntrerpret1.restorativeOptions.label}</li>}
                                                teeth={this.teeth}
                                            />
                                            <br />
                                            <PreImplantAligmentSummary
                                                teeth={this.teeth}
                                                label={<li>{this.labelIntrerpret1.preImplantAligment.label}</li>}
                                                preImplantAligment={this.props.preImplantAligment}
                                            />
                                            <li>{this.renderUpsellSmileDesignPreview()}</li>
                                        </>
                                    )}
                                    <li>{this.labelIntrerpret1.additionalInstructionsOrSpecialRequests.label}</li>
                                    <p>{this.props.specialInstructions || 'N/A'}</p>
                                    <p>{this.getNotes('additionalInstructionsOrSpecialRequestsRemark')}</p>
                                </ol>
                                <div className={style.lastList}></div>
                            </>
                        )}

                        {smileDesignProductListArray.includes(NewCaseType) && (
                            <>
                                {this.props.smileDesign.smileDesignPrescriptionFormIsValid ? (
                                    <SmileDesignPrescriptionNotesPreview
                                        defaultValues={this.props.smileDesign.smileDesignPrescriptionFormData}
                                        isMarieGroup={this.props.isMarieGroup}
                                        isSEAGroup={this.props.isSEAGroup}
                                    />
                                ) : (
                                    <div style={{ color: 'red' }}>
                                        {this.get('@NewPatient.smileDesignNotCompleted')}
                                    </div>
                                )}
                            </>
                        )}
                        <ol className={style.list} start={this.getOlStartNumber()}>
                            <li>{this.get('impressions.byCourierLabel')}</li>

                            <div className={styles.radioWrapper}>
                                <p>
                                    {this.props.NewPaitientData.modernCode
                                        ? this.props.NewPaitientData.modernCode
                                        : 'No Customer Pick Up Code Added'}
                                </p>
                            </div>

                            <li>{this.get('impressions.byScannerBrandLabel')}</li>

                            <div className={styles.radioWrapper}>
                                <p>
                                    {this.props.NewPaitientData.scannerBrand
                                        ? this.props.NewPaitientData.scannerBrand
                                        : 'No Scanner Brand Added'}
                                </p>
                            </div>

                            <li>{this.get('impressions.byScannerUserNameLabel')}</li>

                            <div className={styles.radioWrapper}>
                                <p>
                                    {this.props.NewPaitientData.doctorId
                                        ? this.props.NewPaitientData.doctorId
                                        : 'No Doctor Code Added'}
                                </p>
                            </div>
                        </ol>

                        <div className={style.UploadedImages}>
                            {NewCaseType !== 'RETAINER' && (
                                <>
                                    <p>{this.get('summary.allPhotos')}</p>
                                    <Grid container>
                                        {(() => {
                                            // Filter the photos visible in the active form version.
                                            const photoFiles = this.props.NewPaitientData.files.filter(
                                                file =>
                                                    file.category === 'photo' &&
                                                    (this.props.displayFirstFitFlag ||
                                                        file.id !== 'big_smile_full_face_with_full_retractors')
                                            );
                                            
                                            // 2. 复制数组避免修改原数据
                                            const reorderedPhotos = [...photoFiles];
                                            
                                            // 3. 移动元素：第12条移到第6条（索引11移到索引5）
                                            if (reorderedPhotos.length >= 12) {
                                                const [movedItem] = reorderedPhotos.splice(11, 1); // 删除第12条
                                                reorderedPhotos.splice(5, 0, movedItem);           // 插入到第6条位置
                                            }
                                            // 4. 渲染重新排序后的数组
                                            return reorderedPhotos.map(
                                                (value, index) =>
                                                    value.category === 'photo' && (
                                                        <Grid item xs={4} key={index}>
                                                            {value.uploaded ? (
                                                                <Zoom zoomMargin={48}>
                                                                    <img
                                                                        src={`${value.dataURL ?? value.data}`}
                                                                        style={{
                                                                            maxHeight: '300px',
                                                                            width: 'auto',
                                                                            marginLeft: 'auto',
                                                                            marginRight: 'auto',
                                                                            maxWidth: '100%',
                                                                            transform: value.flipped
                                                                                ? `scaleX(-1) rotateZ(${value.rotate}deg)`
                                                                                : `rotateZ(${value.rotate}deg)`,
                                                                        }}
                                                                    />
                                                                </Zoom>
                                                            ) : (
                                                                <img
                                                                    src={getWebAbsPath('/img/uploadLater.png')}
                                                                    style={{
                                                                        maxHeight: '300px',
                                                                        width: 'auto',
                                                                        marginLeft: 'auto',
                                                                        marginRight: 'auto',
                                                                        maxWidth: '100%',
                                                                        transform: value.flipped
                                                                            ? `scaleX(-1) rotateZ(${value.rotate}deg)`
                                                                            : `rotateZ(${value.rotate}deg)`,
                                                                    }}
                                                                />
                                                            )}
                                                        </Grid>
                                                    )
                                            )
                                        })()}
                                    </Grid>

                                    {(this.props.NewPaitientData.facialScan?.dataURL ||
                                        this.props.NewPaitientData.facialScan?.data) && (
                                        <Grid container>
                                            <Grid item xs={4}>
                                                <Box>
                                                    <img
                                                        src={getWebAbsPath('/img/uploaded.png')}
                                                        style={{
                                                            maxHeight: '300px',
                                                            width: 'auto',
                                                            marginLeft: 'auto',
                                                            marginRight: 'auto',
                                                            maxWidth: '100%',
                                                        }}
                                                    />
                                                    <Typography variant="subtitle1">3D Facial Scan</Typography>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    )}

                                    <p>{this.get('summary.allRadiography')}</p>
                                    <Grid container>
                                        {this.props.NewPaitientData.files.map(
                                            (value, index) =>
                                                value.category === 'radio' && (
                                                    <Grid item xs={4} key={index}>
                                                        {value.will_not_upload ? (
                                                            <img
                                                                src={getWebAbsPath('/img/willNotUpload.png')}
                                                                style={{
                                                                    maxHeight: '300px',
                                                                    width: 'auto',
                                                                    marginLeft: 'auto',
                                                                    marginRight: 'auto',
                                                                    maxWidth: '100%',
                                                                    transform: value.flipped
                                                                        ? `scaleX(-1) rotateZ(${value.rotate}deg)`
                                                                        : `rotateZ(${value.rotate}deg)`,
                                                                }}
                                                            />
                                                        ) : value.uploaded ? (
                                                            typeof value.data === 'string' &&
                                                            /^dbx::/.test(value.data) ? (
                                                                <div
                                                                    style={{
                                                                        padding: '25%',
                                                                    }}
                                                                >
                                                                    Uploaded in Dropbox
                                                                </div>
                                                            ) : (
                                                                <img
                                                                    src={`${value.dataURL ?? value.data}`}
                                                                    style={{
                                                                        maxHeight: '300px',
                                                                        width: 'auto',
                                                                        marginLeft: 'auto',
                                                                        marginRight: 'auto',
                                                                        maxWidth: '100%',
                                                                        transform: value.flipped
                                                                            ? `scaleX(-1) rotateZ(${value.rotate}deg)`
                                                                            : `rotateZ(${value.rotate}deg)`,
                                                                    }}
                                                                />
                                                            )
                                                        ) : (
                                                            <img
                                                                src={getWebAbsPath('/img/uploadLater.png')}
                                                                style={{
                                                                    maxHeight: '300px',
                                                                    width: 'auto',
                                                                    marginLeft: 'auto',
                                                                    marginRight: 'auto',
                                                                    maxWidth: '100%',
                                                                    transform: value.flipped
                                                                        ? `scaleX(-1) rotateZ(${value.rotate}deg)`
                                                                        : `rotateZ(${value.rotate}deg)`,
                                                                }}
                                                            />
                                                        )}
                                                    </Grid>
                                                )
                                        )}
                                    </Grid>
                                </>
                            )}
                            {NewCaseType === 'RETAINER' && (
                                <>
                                    <p>Prescription Note</p>
                                    {!retainerRequestPrescriptionNote.upperPart?.upperRetainerTypeId &&
                                        !retainerRequestPrescriptionNote.lowerPart?.lowerRetainerTypeId && (
                                            <p style={{ color: 'red' }}>
                                                {this.get('@NewPatient.warning.prescription_notes') ||
                                                    Base_Retainer_Request_Err.msg}
                                            </p>
                                        )}

                                    <Grid container>
                                        {retainerRequestPrescriptionNote.upperPart?.upperRetainerTypeId ? (
                                            <ReadOnlyPrescription
                                                impressionType={'upper'}
                                                prescription={retainerRequestPrescriptionNote.upperPart}
                                                isNewCase
                                                isInSummary
                                            />
                                        ) : null}
                                        {retainerRequestPrescriptionNote.lowerPart?.lowerRetainerTypeId ? (
                                            <ReadOnlyPrescription
                                                impressionType={'lower'}
                                                prescription={retainerRequestPrescriptionNote.lowerPart}
                                                isNewCase
                                                isInSummary
                                            />
                                        ) : null}
                                        {retainerRequestPrescriptionNote.specialInsrtuction &&
                                        retainerRequestPrescriptionNote.specialInsrtuction.length > 0 ? (
                                            <ul>
                                                <li>
                                                    <ReadOnlySpecialInstruction
                                                        value={retainerRequestPrescriptionNote.specialInsrtuction}
                                                        isInSummary
                                                    />
                                                </li>
                                            </ul>
                                        ) : null}
                                    </Grid>
                                </>
                            )}
                            <p>{this.get('summary.allImpressions')}</p>
                            <Grid container>
                                {this.props.NewPaitientData.files
                                    .filter((value) => value.category === 'stl_file')
                                    .map((value, index) => (
                                        <Grid item xs={4} key={index}>
                                            {value.uploaded ? (
                                                <Box>
                                                    <img
                                                        src={`${value.data ? getWebAbsPath('/img/uploaded.png') : getWebAbsPath('/img/imageUpload.png')}`}
                                                        style={{
                                                            maxHeight: '300px',
                                                            width: 'auto',
                                                            marginLeft: 'auto',
                                                            marginRight: 'auto',
                                                            maxWidth: '100%',
                                                            transform: value.flipped
                                                                ? `scaleX(-1) rotateZ(${value.rotate}deg)`
                                                                : `rotateZ(${value.rotate}deg)`,
                                                        }}
                                                    />
                                                    <Typography variant="subtitle1">
                                                        {['Upper STL', 'Lower STL', 'Bite 1 STL', 'Bite 2 STL'][index]}
                                                    </Typography>
                                                </Box>
                                            ) : (
                                                <Box>
                                                    <img
                                                        src={getWebAbsPath('/img/uploadLater.png')}
                                                        style={{
                                                            maxHeight: '300px',
                                                            width: 'auto',
                                                            marginLeft: 'auto',
                                                            marginRight: 'auto',
                                                            maxWidth: '100%',
                                                            transform: value.flipped
                                                                ? `scaleX(-1) rotateZ(${value.rotate}deg)`
                                                                : `rotateZ(${value.rotate}deg)`,
                                                        }}
                                                    />
                                                    <Typography variant="subtitle1">
                                                        {['Upper STL', 'Lower STL', 'Bite 1 STL', 'Bite 2 STL'][index]}
                                                    </Typography>
                                                </Box>
                                            )}
                                        </Grid>
                                    ))}
                            </Grid>
                            <Grid container>
                                <ul className={style.errorList}>
                                    {this.getErrorList().map((v, index) => !v.valid && <li key={index}>{v.msg}</li>)}
                                </ul>
                            </Grid>
                        </div>
                    </div>
                </Grid>
                )}

                <Grid item xs={12} sm={NewCaseType === CASE_TYPE.SELF_DESIGN ? 12 : 4}>
                    <div className={style.UserInfo}>
                        <div className={style.userImage}>
                            <img
                                src={
                                    (typeof this.props.NewPaitientData.patientPhoto === 'object' &&
                                        this.props.NewPaitientData.patientPhoto.data === null) ||
                                    (typeof this.props.NewPaitientData.patientPhoto === 'string' &&
                                        this.props.NewPaitientData.patientPhoto === '')
                                        ? getWebAbsPath('/img/front_smile.png')
                                        : this.props.NewPaitientData.patientPhoto.dataURL
                                }
                                style={
                                    this.props.NewPaitientData.patientPhoto?.rotate
                                        ? {
                                              transform: `rotateZ(${this.props.NewPaitientData.patientPhoto.rotate}deg)`,
                                          }
                                        : null
                                }
                            />
                        </div>

                        <div className={style.UserData}>
                            <ul>
                                <li>
                                    {this.get(':fields.name')} : {this.props.NewPaitientData.firstName}{' '}
                                    {this.props.NewPaitientData.lastName}
                                </li>
                                <li>
                                    {this.get(':fields.gender')} : {this.props.NewPaitientData.gender}
                                </li>
                                <li>
                                    {this.get(':fields.dateOfBirth')} : {this.props.NewPaitientData.day}-
                                    {this.props.NewPaitientData.month}-{this.props.NewPaitientData.year}
                                </li>
                                {this.props.NewPaitientData.remarks &&
                                    this.props.NewPaitientData.remarks.split('\n').map((v) => (
                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <StarRateIcon />
                                            {v}
                                        </div>
                                    ))}
                            </ul>
                        </div>
                    </div>

                    <p>
                        <strong>{this.get(':fields.deliveryAddress')}</strong>: {this.props.NewAddressData.address}
                    </p>
                    {this.props.NewAddressData.city && (
                        <p>
                            <strong>{this.get(':fields.city')}</strong>: {this.props.NewAddressData.city}
                        </p>
                    )}
                    {this.props.NewAddressData.zipCode && (
                        <p>
                            <strong>{this.get(':fields.postCode')}</strong>: {this.props.NewAddressData.zipCode}
                        </p>
                    )}
                    {this.props.NewAddressData.phoneNumber && (
                        <p>
                            <strong>{this.get(':fields.phoneNo')}</strong>: {this.props.NewAddressData.phoneNumber}
                        </p>
                    )}

                    <p>
                        <strong>{this.get(':fields.promotionCode')}</strong> :{' '}
                        {this.props.NewPaitientData.promotionCode ? this.props.NewPaitientData.promotionCode : 'None'}
                    </p>
                </Grid>
            </Grid>
        );
    }
}

/**
 * Maps Redux state to New Patient Summary props.
 */
const mapStateToProps = (store) => {
    return {
        NewPaitientData: store.newPatientReducer,
        archToTreat: store.newPatientReducer.archToTreat,
        notToTreat: store.newPatientReducer.notToTreat1,
        attachments: store.newPatientReducer.attachments1,
        alignersMarginPlacement: store.newPatientReducer.alignersMarginPlacement1,
        anteriorPosteriorRelationship: store.newPatientReducer.anteriorPosteriorRelationship1,
        spacingAndCrowding: store.newPatientReducer.spacingAndCrowding1,
        overJet: store.newPatientReducer.overJet1,
        openbite: store.newPatientReducer.openbite1,
        deepBite: store.newPatientReducer.deepBite1,
        midline: store.newPatientReducer.midline1,
        posteriorCrossbite: store.newPatientReducer.posteriorCrossbite1,
        cuttingOptions: store.newPatientReducer.cuttingOptions1,
        auxiliaries: store.newPatientReducer.auxiliaries1,
        specialInstructions: store.newPatientReducer.specialInstructions1,
        trioDimForce: store.newPatientReducer.trioDimForce,
        NewAddressData: store.newAddressReducer,
        lang: store.lang,
        smileDesign: store.smileDesign,
        diffRetainer: store.diffRetainer,
        restorativeOptions: store.newPatientReducer.restorativeOptions,
        preImplantAligment: store.newPatientReducer.preImplantAligment,
        userAllowedFeatures: store.userAllowedFeatures,
        displayFirstFitFlag: store.globalReducer.displayFirstFitFlag,
    };
};

export default connect(mapStateToProps)(withLang(NewPatientSummary, 'NewPatient'));

function questionFiliter1(array, matchValue) {
    if (!array || !matchValue) return '';
    const afterFilter = array.filter(({ value }) => value === matchValue);
    if (!afterFilter.length) return '';
    return afterFilter[0].label;
}

function questionFiliter(array, matchValue) {
    if (!array || !matchValue) return '';
    const afterFilter = array.filter(({ value }) => value === matchValue);
    if (!afterFilter.length) return '';
    return <>{afterFilter[0].label}</>;
}

function checkBoxAssociated(label, boolean, label2) {
    if (!boolean) return <></>;
    if (label2)
        return (
            <>
                {label} : {label2}
            </>
        );
    return <>{label}</>;
}
